module.exports = __webpack_public_path__ + "static/media/lto-dill-dt-fr.bcfdd91f.jpg";